import React from 'react';

import {
  Stack as MuiStack,
  styled,
  SvgIconTypeMap,
  Typography
} from '@mui/material';

import { OverridableComponent } from '@mui/material/OverridableComponent';



const StyledTypography = styled(Typography)(() => ({
  fontSize: 12,
  color: '#528898'
}));

const Stack = styled(MuiStack)<{ onClick?: () => void; }>(({ theme, onClick }) => ({
  cursor: onClick ? 'pointer' : 'default'
}));



export interface IProps {
  icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  iconText: string;

  onClick?: () => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Stack
      spacing={1}
      direction="row"
      alignItems="center"
      onClick={props.onClick}>
      <props.icon
        fontSize="small"
        style={{ color: '#528898' }} />

      <StyledTypography>
        {props.iconText}
      </StyledTypography>
    </Stack>
  );
};
